import { useState } from "react";
import { saveRequestTrip } from "../Api/RequestTrip";
import { Container, Form, Button, Row, Col, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
//import "../Styling/RequestTrip.css";

const RequestTrip = () => {
  const userId = localStorage.getItem("userId") || "5";
  
  const [tripData, setTripData] = useState({
    tripName: "",
    purposeofTravel: "",
    employeeId: "",
    department: "",
    managerId: "",
    tripStartDate: "",
    tripEndDate: "",
    tripType: "",
    createdBy: userId,
    flightData: [],
    trainData: [],
    hotelData: [],
    carRantalData: [],
    busData: []
  });

  const [activeTransport, setActiveTransport] = useState(null);
  const [loading, setLoading] = useState(false);

  const tripTypeOptions = [
    { value: "domestic", label: "Domestic Trip" },
    { value: "international", label: "International Trip" },
  ];

  const companyOptions = [
    { value: "1000", label: "1000 - STPL" },
    { value: "2000", label: "2000 - STPL - Lucknow" },
    { value: "3000", label: "3000 - Discovery Wines" },
  ];

  const seatOptions = [
    { value: "window", label: "Window" },
    { value: "middle", label: "Middle" },
    { value: "aisle", label: "Aisle" },
    { value: "upper", label: "Upper" },
    { value: "lower", label: "Lower" },
  ];

  const mealOptions = [
    { value: "veg", label: "Veg" },
    { value: "nonveg", label: "Non Veg" },
  ];

  const trainClassOptions = [
    { value: "firstac", label: "First AC" },
    { value: "secondac", label: "Second AC" },
    { value: "thirdac", label: "Third AC" },
    { value: "sleeper", label: "Sleeper" },
    { value: "acchair", label: "AC Chair Car" },
    { value: "secondseating", label: "Second Seating" },
  ];

  const busTypeOptions = [
    { value: "shuttle", label: "Shuttle" },
    { value: "volvo", label: "Volvo" },
    { value: "minibus", label: "Mini Bus" },
    { value: "doubledecker", label: "Double Decker" },
  ];

  const carTypeOptions = [
    { value: "mini", label: "Mini" },
    { value: "suv", label: "SUV" },
    { value: "hatchback", label: "Hatchback" },
  ];

  const yesNoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  const handleChange = (e) => {
    setTripData({ ...tripData, [e.target.name]: e.target.value });
  };

  const handleFlightChange = (index, e) => {
    const { name, value } = e.target;
    const flightData = [...tripData.flightData];
    flightData[index] = { ...flightData[index], [name]: value, createdBy: userId };
    setTripData({ ...tripData, flightData });
  };

  const handleTrainChange = (index, e) => {
    const { name, value } = e.target;
    const trainData = [...tripData.trainData];
    trainData[index] = { ...trainData[index], [name]: value, createdBy: userId };
    setTripData({ ...tripData, trainData });
  };

  const handleHotelChange = (index, e) => {
    const { name, value } = e.target;
    const hotelData = [...tripData.hotelData];
    hotelData[index] = { ...hotelData[index], [name]: value, createdBy: userId };
    setTripData({ ...tripData, hotelData });
  };

  const handleCabChange = (index, e) => {
    const { name, value } = e.target;
    const carRantalData = [...tripData.carRantalData];
    carRantalData[index] = { ...carRantalData[index], [name]: value, createdBy: userId };
    setTripData({ ...tripData, carRantalData });
  };

  const handleBusChange = (index, e) => {
    const { name, value } = e.target;
    const busData = [...tripData.busData];
    busData[index] = { ...busData[index], [name]: value, createdBy: userId };
    setTripData({ ...tripData, busData });
  };

  const addFlight = () => {
    setTripData({
      ...tripData,
      flightData: [
        ...tripData.flightData,
        {
          departFrom: "",
          arriveAt: "",
          departureDate: "",
          departureTime: "",
          seatPreference: "",
          mealPreference: "",
          company: "",
          createdBy: userId
        }
      ]
    });
    setActiveTransport('flight');
  };

  const addTrain = () => {
    setTripData({
      ...tripData,
      trainData: [
        ...tripData.trainData,
        {
          departFrom: "",
          arriveAt: "",
          departureDate: "",
          departureTime: "",
          classPreference: "",
          seatPreference: "",
          mealPreference: "",
          company: "",
          age: "",
          createdBy: userId
        }
      ]
    });
    setActiveTransport('train');
  };

  const addHotel = () => {
    setTripData({
      ...tripData,
      hotelData: [
        ...tripData.hotelData,
        {
          locations: "",
          checkIn: "",
          checkOut: "",
          descriptions: "",
          company: "",
          createdBy: userId
        }
      ]
    });
    setActiveTransport('hotel');
  };

  const addCab = () => {
    setTripData({
      ...tripData,
      carRantalData: [
        ...tripData.carRantalData,
        {
          pickUpCity: "",
          pickUpDate: "",
          pickUpTime: "",
          dropOffCity: "",
          dropOffDate: "",
          dropOffTime: "",
          carType: "",
          driverNeeded: "",
          company: "",
          createdBy: userId
        }
      ]
    });
    setActiveTransport('cab');
  };

  const addBus = () => {
    setTripData({
      ...tripData,
      busData: [
        ...tripData.busData,
        {
          departFrom: "",
          arriveAt: "",
          departureDate: "",
          departureTime: "",
          busPreference: "",
          seatPreference: "",
          mealPreference: "",
          company: "",
          createdBy: userId
        }
      ]
    });
    setActiveTransport('bus');
  };

  const removeFlight = (index) => {
    const flightData = [...tripData.flightData];
    flightData.splice(index, 1);
    setTripData({ ...tripData, flightData });
  };

  const removeTrain = (index) => {
    const trainData = [...tripData.trainData];
    trainData.splice(index, 1);
    setTripData({ ...tripData, trainData });
  };

  const removeHotel = (index) => {
    const hotelData = [...tripData.hotelData];
    hotelData.splice(index, 1);
    setTripData({ ...tripData, hotelData });
  };

  const removeCab = (index) => {
    const carRantalData = [...tripData.carRantalData];
    carRantalData.splice(index, 1);
    setTripData({ ...tripData, carRantalData });
  };

  const removeBus = (index) => {
    const busData = [...tripData.busData];
    busData.splice(index, 1);
    setTripData({ ...tripData, busData });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    if (
      tripData.flightData.length === 0 &&
      tripData.trainData.length === 0 &&
      tripData.hotelData.length === 0 &&
      tripData.carRantalData.length === 0 &&
      tripData.busData.length === 0
    ) {
      toast.error("Please select at least one transport option to add");
      setLoading(false);
      return;
    }

    try {
      await saveRequestTrip(tripData);
      toast.success("Trip Request Saved Successfully");
      // Reset form
      setTripData({
        tripName: "",
        purposeofTravel: "",
        employeeId: "",
        department: "",
        managerId: "",
        tripStartDate: "",
        tripEndDate: "",
        tripType: "",
        createdBy: userId,
        flightData: [],
        trainData: [],
        hotelData: [],
        carRantalData: [],
        busData: []
      });
    } catch (error) {
      toast.error("Failed to save trip request");
      console.error("Error details:", error.response?.data);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Request Trip</h2>

          {loading && (
            <div className="loading-overlay">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Trip Name <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="tripName"
                    value={tripData.tripName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Purpose of Travel <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="purposeofTravel"
                    value={tripData.purposeofTravel}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Employee ID <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="employeeId"
                    value={tripData.employeeId}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Department <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="department"
                    value={tripData.department}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Manager ID <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="managerId"
                    value={tripData.managerId}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Trip Start Date <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="tripStartDate"
                    value={tripData.tripStartDate}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Trip End Date <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="tripEndDate"
                    value={tripData.tripEndDate}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Trip Type <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="tripType"
                    value={tripData.tripType}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Trip Type</option>
                    {tripTypeOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <div className="transport-options-section">
              <h4 className="transport-options-heading">Transport Options</h4>
              
              <div className="transport-buttons mb-4">
                <Button variant="primary" onClick={addFlight} className="me-2">
                  Add Flight
                </Button>
                <Button variant="secondary" onClick={addTrain} className="me-2">
                  Add Train
                </Button>
                <Button variant="success" onClick={addHotel} className="me-2">
                  Add Hotel
                </Button>
                <Button variant="warning" onClick={addCab} className="me-2">
                  Add Cab
                </Button>
                <Button variant="info" onClick={addBus}>
                  Add Bus
                </Button>
              </div>

              {/* Flight Forms */}
              {tripData.flightData.map((flight, index) => (
                <div key={`flight-${index}`} className="transport-form-container mb-4 p-3 bg-light rounded">
                  <h5>Flight #{index + 1}</h5>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Depart From <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="departFrom"
                          value={flight.departFrom}
                          onChange={(e) => handleFlightChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Arrive At <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="arriveAt"
                          value={flight.arriveAt}
                          onChange={(e) => handleFlightChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Departure Date <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="date"
                          name="departureDate"
                          value={flight.departureDate}
                          onChange={(e) => handleFlightChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Departure Time <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="time"
                          name="departureTime"
                          value={flight.departureTime}
                          onChange={(e) => handleFlightChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Seat Preference <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="seatPreference"
                          value={flight.seatPreference}
                          onChange={(e) => handleFlightChange(index, e)}
                          required
                        >
                          <option value="">Select Seat</option>
                          {seatOptions.filter(opt => ['window', 'middle', 'aisle'].includes(opt.value)).map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Meal Preference <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="mealPreference"
                          value={flight.mealPreference}
                          onChange={(e) => handleFlightChange(index, e)}
                          required
                        >
                          <option value="">Select Meal</option>
                          {mealOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Company <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="company"
                          value={flight.company}
                          onChange={(e) => handleFlightChange(index, e)}
                          required
                        >
                          <option value="">Select Company</option>
                          {companyOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4} className="d-flex align-items-end">
                      <Button 
                        variant="danger" 
                        onClick={() => removeFlight(index)}
                        className="transport-remove-btn"
                      >
                        Remove Flight
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}

              {/* Train Forms */}
              {tripData.trainData.map((train, index) => (
                <div key={`train-${index}`} className="transport-form-container mb-4 p-3 bg-light rounded">
                  <h5>Train #{index + 1}</h5>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Depart From <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="departFrom"
                          value={train.departFrom}
                          onChange={(e) => handleTrainChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Arrive At <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="arriveAt"
                          value={train.arriveAt}
                          onChange={(e) => handleTrainChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Departure Date <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="date"
                          name="departureDate"
                          value={train.departureDate}
                          onChange={(e) => handleTrainChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Departure Time <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="time"
                          name="departureTime"
                          value={train.departureTime}
                          onChange={(e) => handleTrainChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Class Preference <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="classPreference"
                          value={train.classPreference}
                          onChange={(e) => handleTrainChange(index, e)}
                          required
                        >
                          <option value="">Select Class</option>
                          {trainClassOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Age <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="number"
                          name="age"
                          value={train.age}
                          onChange={(e) => handleTrainChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Seat Preference <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="seatPreference"
                          value={train.seatPreference}
                          onChange={(e) => handleTrainChange(index, e)}
                          required
                        >
                          <option value="">Select Seat</option>
                          {seatOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Meal Preference <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="mealPreference"
                          value={train.mealPreference}
                          onChange={(e) => handleTrainChange(index, e)}
                          required
                        >
                          <option value="">Select Meal</option>
                          {mealOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Company <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="company"
                          value={train.company}
                          onChange={(e) => handleTrainChange(index, e)}
                          required
                        >
                          <option value="">Select Company</option>
                          {companyOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12} className="d-flex justify-content-end">
                      <Button 
                        variant="danger" 
                        onClick={() => removeTrain(index)}
                        className="transport-remove-btn"
                      >
                        Remove Train
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}

              {/* Hotel Forms */}
              {tripData.hotelData.map((hotel, index) => (
                <div key={`hotel-${index}`} className="transport-form-container mb-4 p-3 bg-light rounded">
                  <h5>Hotel #{index + 1}</h5>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Location <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="locations"
                          value={hotel.locations}
                          onChange={(e) => handleHotelChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Company <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="company"
                          value={hotel.company}
                          onChange={(e) => handleHotelChange(index, e)}
                          required
                        >
                          <option value="">Select Company</option>
                          {companyOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Check In <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="date"
                          name="checkIn"
                          value={hotel.checkIn}
                          onChange={(e) => handleHotelChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Check Out <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="date"
                          name="checkOut"
                          value={hotel.checkOut}
                          onChange={(e) => handleHotelChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Descriptions <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="descriptions"
                          value={hotel.descriptions}
                          onChange={(e) => handleHotelChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12} className="d-flex justify-content-end">
                      <Button 
                        variant="danger" 
                        onClick={() => removeHotel(index)}
                        className="transport-remove-btn"
                      >
                        Remove Hotel
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}

              {/* Cab Forms */}
              {tripData.carRantalData.map((cab, index) => (
                <div key={`cab-${index}`} className="transport-form-container mb-4 p-3 bg-light rounded">
                  <h5>Cab #{index + 1}</h5>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Pick Up City <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="pickUpCity"
                          value={cab.pickUpCity}
                          onChange={(e) => handleCabChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Drop Off City <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="dropOffCity"
                          value={cab.dropOffCity}
                          onChange={(e) => handleCabChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Pick Up Date <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="date"
                          name="pickUpDate"
                          value={cab.pickUpDate}
                          onChange={(e) => handleCabChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Pick Up Time <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="time"
                          name="pickUpTime"
                          value={cab.pickUpTime}
                          onChange={(e) => handleCabChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Drop Off Date <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="date"
                          name="dropOffDate"
                          value={cab.dropOffDate}
                          onChange={(e) => handleCabChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Drop Off Time <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="time"
                          name="dropOffTime"
                          value={cab.dropOffTime}
                          onChange={(e) => handleCabChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Car Type <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="carType"
                          value={cab.carType}
                          onChange={(e) => handleCabChange(index, e)}
                          required
                        >
                          <option value="">Select Car Type</option>
                          {carTypeOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Driver Needed <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="driverNeeded"
                          value={cab.driverNeeded}
                          onChange={(e) => handleCabChange(index, e)}
                          required
                        >
                          <option value="">Select Option</option>
                          {yesNoOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Company <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="company"
                          value={cab.company}
                          onChange={(e) => handleCabChange(index, e)}
                          required
                        >
                          <option value="">Select Company</option>
                          {companyOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12} className="d-flex justify-content-end">
                      <Button 
                        variant="danger" 
                        onClick={() => removeCab(index)}
                        className="transport-remove-btn"
                      >
                        Remove Cab
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}

              {/* Bus Forms */}
              {tripData.busData.map((bus, index) => (
                <div key={`bus-${index}`} className="transport-form-container mb-4 p-3 bg-light rounded">
                  <h5>Bus #{index + 1}</h5>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Depart From <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="departFrom"
                          value={bus.departFrom}
                          onChange={(e) => handleBusChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Arrive At <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="arriveAt"
                          value={bus.arriveAt}
                          onChange={(e) => handleBusChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Departure Date <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="date"
                          name="departureDate"
                          value={bus.departureDate}
                          onChange={(e) => handleBusChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Departure Time <span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="time"
                          name="departureTime"
                          value={bus.departureTime}
                          onChange={(e) => handleBusChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Bus Preference <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="busPreference"
                          value={bus.busPreference}
                          onChange={(e) => handleBusChange(index, e)}
                          required
                        >
                          <option value="">Select Bus Type</option>
                          {busTypeOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Seat Preference <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="seatPreference"
                          value={bus.seatPreference}
                          onChange={(e) => handleBusChange(index, e)}
                          required
                        >
                          <option value="">Select Seat</option>
                          {seatOptions.filter(opt => ['window', 'middle', 'aisle', 'upper', 'lower'].includes(opt.value)).map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Meal Preference <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="mealPreference"
                          value={bus.mealPreference}
                          onChange={(e) => handleBusChange(index, e)}
                          required
                        >
                          <option value="">Select Meal</option>
                          {mealOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Company <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="company"
                          value={bus.company}
                          onChange={(e) => handleBusChange(index, e)}
                          required
                        >
                          <option value="">Select Company</option>
                          {companyOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Button 
                          variant="danger" 
                          onClick={() => removeBus(index)}
                          className="transport-remove-btn"
                        >
                          Remove Bus
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              ))}
            </div>

            <div className="fields-btn-container">
              <Button
                variant="primary"
                type="submit"
                className="fields-submit"
                disabled={loading}
              >
                {loading ? "Saving..." : "Submit Trip Request"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
  );
};

export default RequestTrip;